import { render, staticRenderFns } from "./EditFormBuilder.vue?vue&type=template&id=7287da8a"
import script from "./EditFormBuilder.vue?vue&type=script&lang=ts"
export * from "./EditFormBuilder.vue?vue&type=script&lang=ts"
import style0 from "@/scss/common/inputs-row.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports